import { defineFcm } from '../shared/factory';

export const FCM_DECISION_MAKERS_AUTOADD_ENABLED = defineFcm('decision_makers_autoadd_enabled')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-capybara',
		scope: 'petition-service',
		context: 'Controls whether recommended decision makers are automatically added to a petition',
		description:
			'In petition service, after decision makers are recommended, this flag controls whether they are automatically added to the petition (if no decision makers have been added yet)',
	});
